import Index from './Invoices'
import IndexHeading from './IndexHeading'
import Show from './Show'
import ShowHeading from './ShowHeading'
import ShowPublic from './ShowPublic'

export default {
  Index,
  IndexHeading,
  ShowHeading,
  Show,
  ShowPublic
}



// WEBPACK FOOTER //
// ./src/components/invoices/index.js